import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  from,
} from "@apollo/client";
import { TokenRefreshLink } from "apollo-link-token-refresh";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { API_URL } from "@/constants/env";
import { useDispatch } from "react-redux";

import AuthActions from "@/store/auth/actions";

import { isUnauthorized, notGuestPath } from "./helper";

const MydaApolloClient = ({ children }) => {
  const accessToken = Cookies.get("accessToken");

  const dispatch = useDispatch();

  const httpLink = createHttpLink({
    uri: API_URL,
  });

  const errorLink = onError(
    ({ graphQLErrors, networkError, operation, forward }) => {
      if (graphQLErrors)
        if (isUnauthorized(graphQLErrors) && notGuestPath()) {
          return;
        }
      if (networkError) console.log(`[Network error]: ${networkError}`);
    }
  );

  const authLink = setContext((_, { headers }) => {
    try {
      const access_token = Cookies.get("accessToken");
      const merchantId = headers?.merchantId;
      const storeId = headers?.storeId;
      return {
        headers: {
          Authorization: access_token
            ? `Bearer ${access_token}`
            : "Bearer Guest",
          "content-type": "application/json",
          ...(merchantId && { "x-metadata-merchant": merchantId }),
          ...(storeId && { "x-metadata-store": storeId }),
        },
      };
    } catch (error) {
      console.log("Error: ", error);
    }
  });

  const refreshTokenLink = new TokenRefreshLink({
    accessTokenField: "refresh_token",
    isTokenValidOrUndefined: () => {
      const access_token = Cookies.get("accessToken");
      if (!access_token) return true;
      try {
        const { exp } = jwtDecode(access_token);
        const expires = new Date(exp * 1000);
        if (Date.now() >= expires) return false;
        return true;
      } catch {
        return false;
      }
    },
    fetchAccessToken: () => {
      const refresh_token = Cookies.get("refreshToken");
      return fetch(API_URL, {
        method: "POST",
        headers: {
          Authorization: `Bearer Guest`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: `mutation refreshToken {
            refresh_token(token: "${refresh_token}") {
              access_token,
              refresh_token,
            }
          }`,
        }),
      });
    },
    handleFetch: ({ access_token, refresh_token }) => {
      console.log("handleFetch--->");
      dispatch(AuthActions.updateAuthTokens(access_token, refresh_token));
    },
    handleError: (error) => {
      console.log("refresh token error--->", JSON.stringify(error));
      dispatch(AuthActions.logout());
    },
  });

  const client = new ApolloClient({
    link: from([refreshTokenLink, authLink, errorLink, httpLink]),
    cache: new InMemoryCache(),
    connectToDevTools: true,
  });

  if (!accessToken) {
    client.cache.reset();
  }

  return children(client);
};

export default MydaApolloClient;
